import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../../baseQuery/basePlatformQuery';
import { Product } from '../../tenant/types';
import { ProductsQueryParams } from './types';

const BASE_URL = "/api/v1/admin/products"

export const productsApi = createApi({
    reducerPath: 'productsApi',
    baseQuery,
    endpoints: (builder) => ({
        getProducts: builder.query<Array<Product>, ProductsQueryParams>({
            query: ({ search, pageNumber, pageSize }) => {
                const params = new URLSearchParams();
                if (search) params.append('SearchString', search);
                if (pageNumber) params.append('PageNumber', pageNumber.toString());
                if (pageSize) params.append('PageSize', pageSize.toString());
                return {
                    url: `${BASE_URL}/search`,
                    params,
                };
            },
        }),
        getTenantProducts: builder.query<Array<Product>, void>({
            query: () => ({
                url: `/api/v1/tenant/products`,
                method: 'GET',
            }),
        }),
    }),
});

export const { useGetProductsQuery, useGetTenantProductsQuery } = productsApi;
